import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useCallback,
} from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import ProductPageWithImg from "../productPage/ProductPageWithImg";
import ProductLocationPopUp from "../productPage/ProductLocationPopUp";
import { globalFileServer } from "../../../../axiosInstance";
import { getFilters } from "../../../server/Filter";
import { getAllPerCategoryId } from "../../../server/Advertising";
import {
  getSales,
  getItemsPerCategoryDispatch,
  UpdateSort,
  getItemsPerWord,
  reloedFunc,
} from "../../../server/Product";
import { useDispatch, useSelector } from "react-redux";
import PopUp from "../../containers/PopUp";
import Card from "../card/Card";
import { getAllCategory } from "../../../server/Category";
import CategoryHeaderPage from "../CategoryPageHeder";
import ProductAddToShoppingList from "../productPage/ProductAddToShoppingList";
import { setToggleSidebar } from "../../../server/CartsOpen";
import { showAlertWithConfirmCancel } from "../../../server/ShowAlert";
import { render } from "@testing-library/react";

const CategoryPage = ({
  allProduct,
  adminToCustomer,
  setCurrentSubCategory,
  currentSubCategory,
}) => {
  const navigate = useNavigate();
  const dragItem = useRef();
  const dragOverItem = useRef();
  const { id, FatherId, subId } = useParams();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const {
    categories,
    categoriesParent,
    filterList,
    stationId,
    role,
    refresh,
    reloed,
    items,
    searchString,
  } = useSelector((state) => ({
    categories: state.category.categories,
    categoriesParent: state.category.categories.filter(
      (item) => item.Id === parseInt(id)
    ),
    filterList: state.displayProduct.filterList,
    items: state.displayProduct.itemsShow,
    reloed: state.displayProduct.reloed,
    searchString: state.displayProduct.searchString,
    refresh: state.productsInCart.refresh,
    role: state.user.role,
    stationId: state.user.stationId,
  }));
  const [reloedStart, setReloedStart] = useState(false);
  const [itemsShow, setItemsShow] = useState(items);
  const [selectedProd, setSelectedProd] = useState([]);
  const [productPopUp, setProductPopUp] = useState(null);
  const [productLocationPopUp, setProductLocationPopUp] = useState(null);
  const [addToShopListPopUp, setAddToShopListPopUp] = useState(null);
  const [advertising, setAdvertising] = useState([]);
  const [countPage, setCountPage] = useState(30);
  const [pagePlace, setPagePlace] = useState(0);
  const observerRef = useRef(null);
  const [find, setFind] = useState(null);
  const loadingRef = useRef(false);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          const categoryId = entry.target.dataset.categoryId;
          const parentId = entry.target.dataset.parentCategoryId;

          if (!categoryId) return;

          if (categoryId === id) return;

          if (parentId === id) setCurrentSubCategory(categoryId);
          else setCurrentSubCategory(parentId);
        });
      },
      {
        rootMargin: "-40% 0px -40% 0px",
        threshold: 0,
      }
    );

    return () => observerRef.current?.disconnect();
  }, [id]);

  const observeSubCategories = useCallback(() => {
    const anchors = document.querySelectorAll("[data-category-id]");
    anchors.forEach((el) => observerRef.current?.observe(el));
  }, []);

  const handleScroll = useCallback(() => {
    if (loadingRef.current) return;

    const bottom =
      (window.innerHeight + window.scrollY) * 1.2 >=
      document.documentElement.scrollHeight;

    if (bottom) {
      loadingRef.current = true;
      setPagePlace((prev) => prev + 1);

      setTimeout(() => {
        loadingRef.current = false;
      }, 300);
    }

    observeSubCategories();
  }, [observeSubCategories]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [handleScroll]);

  useEffect(() => {
    observeSubCategories();
  }, [pagePlace, observeSubCategories]);

  const getItems = () => {
    getAllPerCategoryId(id).then((x) => setAdvertising(x.data));
    dispatch(reloedFunc());
    if (id) {
      dispatch(getItemsPerCategoryDispatch(id, stationId, adminToCustomer));
    } else if (pathname === "/search" && searchString) {
      dispatch(getItemsPerWord(searchString, stationId));
      setItemsShow(items);
    } else if (pathname === "/sales") {
      dispatch(getSales(stationId));
    }
  };

  useEffect(() => {
    setCurrentSubCategory(null);
    if (!filterList.length) {
      dispatch(getFilters());
    }
  }, [id, pathname, searchString, refresh]);

  useEffect(() => {
    getItems();
  }, [stationId]);

  const sortItems = async () => {
    let moveBefore = true;
    let categoryId = dragItem.current.CategoryId;

    if (
      dragItem.current.CategoryFullOrderNumber <
      dragOverItem.current.CategoryFullOrderNumber
    ) {
      moveBefore = false;
      const foundItem = itemsShow
        .slice()
        .reverse()
        .find(
          (ele) =>
            ele.CategoryFullOrderNumber ===
            dragOverItem.current.CategoryFullOrderNumber
        );

      if (foundItem) {
        dragOverItem.current.Mkt = foundItem.Mkt;
      } else {
        console.warn(
          "Item not found in reversed list:",
          dragOverItem.current.CategoryFullOrderNumber
        );
      }
    }

    if (
      dragItem.current.CategoryFullOrderNumber >
      dragOverItem.current.CategoryFullOrderNumber
    ) {
      const foundItem = itemsShow.find(
        (ele) =>
          ele.CategoryFullOrderNumber ===
          dragOverItem.current.CategoryFullOrderNumber
      );

      if (foundItem) {
        dragOverItem.current.Mkt = foundItem.Mkt;
      } else {
        console.warn(
          "Item not found in list:",
          dragOverItem.current.CategoryFullOrderNumber
        );
      }
    }

    const data = {
      Mkt: dragOverItem.current.Mkt,
      MktChange: dragItem.current.Mkt,
      isBefore: moveBefore,
      CategoryId: categoryId,
    };

    showAlertWithConfirmCancel({
      msgTitle: "הפעולה הזו תשנה את סדר הפריטים. האם ברצונך להמשיך?",
      confirmText: "אישור",
      cancelText: "ביטול",
      onConfirm: () => {
        try {
          dispatch(UpdateSort(data, stationId, adminToCustomer));
        } catch (error) {
          console.error("Error updating sort:", error);
        }
      },
    });
  };

  useEffect(() => {
    getItems();
  }, [adminToCustomer]);

  useEffect(() => {
    if (!reloed && reloedStart)
      setFind(() =>
        itemsShow.find(
          (x) =>
            x.CategoryFather1OrderNumber == id ||
            x.CategoryId == id ||
            x.CategoryFatherOrderNumber == id ||
            x.FatherId == id ||
            x.FatherFatherId == id
        )
      );
  }, [itemsShow]);

  useEffect(() => {
    if (reloed) setReloedStart(() => true);
  }, [reloed]);

  const maxItemsToRender = countPage * (pagePlace + 1);
  let renderedItemsCount = 0;

  const renderCategoryNode = (node) => {
    if (!node || renderedItemsCount >= maxItemsToRender) return null;

    let categoryHasRenderedProducts = false;
    const renderedProducts = [];

    if (node.products && node.products.length) {
      for (let i = 0; i < node.products.length; i++) {
        if (renderedItemsCount >= maxItemsToRender) break;

        const element = node.products[i];
        renderedItemsCount++;
        categoryHasRenderedProducts = true;

        renderedProducts.push(
          <Fragment key={`${node.id}-product-${i}`}>
            {element.type === "advertising" ? (
              <div>
                <div className="img" onClick={() => navigate(element.Url)}>
                  <img
                    loading="lazy"
                    src={`${globalFileServer}Advertising/${element.PathUrl}`}
                    alt={element.CategoryName}
                  />
                </div>
                {element.type}
              </div>
            ) : (
              <div
                className="col-lg-2"
                data-subcategory-id={element.CategoryId}
                data-parent-category-id={element.FatherId}
                onDragStart={() => (dragItem.current = element)}
                onDragEnter={() => (dragOverItem.current = element)}
                onDragEnd={role ? sortItems : null}
                draggable
              >
                <Card
                  element={element}
                  productPopUp={() => {
                    setProductPopUp(true);
                    setSelectedProd(element);
                    dispatch(setToggleSidebar(false));
                  }}
                  addToShopListPopUp={() => {
                    setAddToShopListPopUp(true);
                    setSelectedProd(element);
                  }}
                  productLocationPopUp={() => {
                    setProductLocationPopUp(true);
                    setSelectedProd(element);
                    dispatch(setToggleSidebar(false));
                  }}
                />
              </div>
            )}
          </Fragment>
        );
      }
    }

    const renderedChildren = [];
    if (
      node.children &&
      node.children.length &&
      renderedItemsCount < maxItemsToRender
    ) {
      for (let i = 0; i < node.children.length; i++) {
        if (renderedItemsCount >= maxItemsToRender) break;
        const child = renderCategoryNode(node.children[i]);
        if (child) renderedChildren.push(child);
      }
    }

    if (!categoryHasRenderedProducts && renderedChildren.length === 0) {
      return null;
    }

    return (
      <Fragment key={node.id}>
        {id !== node.slug && !node.isFamily && renderedProducts.length > 0 && (
          <div
            className="category-name"
            data-category-id={node.slug}
            data-parent-category-id={node.parentSlug}
          >
            <h1>{node.name}</h1>
          </div>
        )}
        {node.isFamily && <div className="category-name" />}
        <>{renderedProducts}</>
        {renderedChildren}
      </Fragment>
    );
  };

  if (
    categoriesParent.length ||
    pathname === "/search" ||
    pathname === "/sales" ||
    pathname.startsWith("/category")
  ) {
    return (
      <div className="products-view">
        <CategoryHeaderPage id={id} FatherId={FatherId} subId={subId} />

        {productPopUp ? (
          <ProductPageWithImg
            selectedProd={selectedProd}
            close={() => setProductPopUp(!productPopUp)}
          />
        ) : null}
        {addToShopListPopUp ? (
          <PopUp width="500px" close={() => setAddToShopListPopUp(false)}>
            <ProductAddToShoppingList
              selectedProd={selectedProd}
              close={() => setAddToShopListPopUp(false)}
            />
          </PopUp>
        ) : null}
        {productLocationPopUp ? (
          <PopUp
            width="900px"
            close={() => setProductLocationPopUp(!productLocationPopUp)}
          >
            <h3>{selectedProd.ProductName}</h3>
            <ProductLocationPopUp product={selectedProd} />{" "}
            <div
              onClick={() => setProductLocationPopUp(!productLocationPopUp)}
              className="overflow"
            ></div>
          </PopUp>
        ) : null}
        {pathname === "/search" ? (
          <h1 className="search-title">חיפוש מוצרים</h1>
        ) : null}
        {pathname === "/sales" ? (
          <h1 className="search-title">מוצרי מבצע</h1>
        ) : null}

        <div className="flex-container">
          <div className="col-lg-9 category-card">
            {reloed ? (
              <h1>טוען מוצרים...</h1>
            ) : items?.length !== 0 ? (
              <>{<>{renderCategoryNode(items)}</>}</>
            ) : (
              <h1>אין מוצרים במלאי</h1>
            )}
          </div>
        </div>
      </div>
    );
  } else {
    return null;
  }
};

export default CategoryPage;
